require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-persons-with-disabilities-in-uganda-face-accessibility.json") })
        }
      }, "path---en-us-update-persons-with-disabilities-in-uganda-face-accessibility");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-persons-with-disabilities-in-uganda-face-accessibility!./.cache/json/en-us-update-persons-with-disabilities-in-uganda-face-accessibility.json
// module id = 783
// module chunks = 231608221292675